<template>
  <div>
    <el-tag size="mini" :type="status.tagType">{{ status.text }}</el-tag>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        0: {
          tagType: "danger",
          text: this.language("awaitDaily_dailyList.未提交"),
        },
        2: {
          tagType: "success",
          text: this.language("awaitDaily_dailyList.已关闭"),
        },
        100: {
          tagType: "danger",
          text: this.language("awaitDaily_dailyList.退回"),
        },
      },
      status: {},
    };
  },
  props: {
    row: Object,
    index: Number,
  },
  methods: {
    getStatus(name) {
        if (this.row.isAudit == 0) {
        if (this.row.submitStatus == 1) {
          this.status = {
            tagType: "info",
            text: this.language("awaitDaily_dailyList.待审核"),
          };
        }else if (this.row.submitStatus == 0) {
          this.status = {
            tagType: "danger",
            text: this.language("awaitDaily_dailyList.未提交"),
          };
        }else if (this.row.submitStatus == 2) {
          this.status = {
            tagType: "danger",
            text: this.language("awaitDaily_dailyList.已关闭"),
          };
        }
      } else if (this.row.isAudit == 1) {
        this.status = {
          tagType: "success",
          text: this.language("awaitDaily_dailyList.审核通过"),
        };
      } else if (this.row.isAudit == 2) {
        this.status = {
          tagType: "danger",
        text:this.language("awaitDaily_dailyList.未提交") + '('+this.language("awaitDaily_dailyList.退回")+')',
        };
      }
    },
  },
  mounted() {
    this.getStatus();
  },
};
</script>